import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cacheAdminApi } from '../api/cacheAdminApi';

/**
 * DELETE /api/eraf/cache-admin/caches/{name} — 단건 evict (CACHE_EVICT)
 * 성공 시 cache-admin 목록 + overview 쿼리 무효화
 */
export function useEvictCache() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (name: string) => cacheAdminApi.evictCache(name),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['cache-admin', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['cache-admin', 'overview'] });
      void queryClient.invalidateQueries({ queryKey: ['cache-admin', 'detail'] });
    },
  });
}
